import React from 'react'

const TenantsPage = () => {
    return (
        <>tenants-page</>
    )
}

export default TenantsPage